import { render, staticRenderFns } from "./GroupsModeration.vue?vue&type=template&id=11b7ceb1&scoped=true&"
import script from "./GroupsModeration.vue?vue&type=script&lang=js&"
export * from "./GroupsModeration.vue?vue&type=script&lang=js&"
import style0 from "./GroupsModeration.vue?vue&type=style&index=0&id=11b7ceb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b7ceb1",
  null
  
)

export default component.exports